
















import { vxm } from '../store.vuex';
import { Component, Vue } from 'vue-property-decorator';
import { RecruiterRequest } from '../models/referrals/recruiterrequest';
import { RecruiterResponse } from '../models/referrals/recruiterresponse';
import { InternalReferralFriendRequest } from '../models/referrals/internalReferralFriendRequest';
import { CommonUserInfo } from '../models/referrals/commonuserinfo';
import { Phone } from '../models/userdata/phone';
import { Recruiter } from '../models/referrals/recruiter';
import FormCard from './ReferAFriend/FormCard.vue';
import FormSection from './ReferAFriend/FormSection.vue';
import SectionContainer from './Commons/SectionContainer.vue';
import SectionTitle from './Commons/SectionTitle.vue';
import SubmitButton from './ReferAFriend/SubmitButton.vue';
import InternalRefUserForm from './ReferAFriend/InternalRefUserForm.vue';
import { ModelListSelect } from 'vue-search-select';
import UserFormValidator from './ReferAFriend/userFormValidator';
import MailClientOpener from '@/components/ReferAFriend/mailClientOpener';
import { mixins } from 'vue-class-component';
import { InternalReferralUserInfo } from '@/models/referrals/internalReferralUserInfo';

@Component({
  name: 'ReferInternalFriend',
  components: {
    FormCard,
    SectionTitle,
    SectionContainer,
    SubmitButton,
    InternalRefUserForm,
    ModelListSelect,
    FormSection,
  },
})
export default class ReferAFriend extends mixins(
  UserFormValidator,
  MailClientOpener,
) {
  private recruiterRequest: RecruiterRequest = new RecruiterRequest();
  private recruiterResponse: RecruiterResponse = new RecruiterResponse();
  private recruiter: Recruiter = new Recruiter();
  private referFriendRequest: InternalReferralFriendRequest = new InternalReferralFriendRequest();
  private friendInfo: InternalReferralUserInfo = new InternalReferralUserInfo();
  private errorString: string = '';
  private successString: string = '';
  private searchText: string = '';
  private componentKey: number = 0;
  $wlToastr: any;

  sendReferFriendRequest() {
    let validationMessage;
    validationMessage = this.internalReferralFormValidator(this.friendInfo);
    if (validationMessage) {
      return this.$wlToastr(
        'error',
        validationMessage,
        this.$t('referafriend.title'),
      );
    }
    if(this.friendInfo.mobile==null && this.friendInfo.phoneNumber.length>0){
      this.friendInfo.phoneNumber = ''
    }
    if (
      this.friendInfo.email === vxm.users.myUserProfile.email ||
      this.friendInfo.phoneNumber === vxm.users.myUserProfile.phoneNum
    ) {
      this.$wlToastr('error', this.$t('quicksignup-details-same-referrer'), '');
      return;
    }
    this.referFriendRequest.friendList.push(this.friendInfo);
    this.referFriendRequest.commonUserInfo.userId =
      vxm.users.myUserProfile.userId;
    this.referFriendRequest.commonUserInfo.firstName =
      vxm.users.myUserProfile.firstName;
    this.referFriendRequest.commonUserInfo.lastName =
      vxm.users.myUserProfile.lastName;
    this.referFriendRequest.commonUserInfo.email =
      vxm.users.myUserProfile.email;
    this.referFriendRequest.commonUserInfo.phoneNumber =
      vxm.users.myUserProfile.phoneNum + '';

    this.referFriendRequest.commonUserInfo.recruiterName = this.recruiter.recruiterName;
    this.referFriendRequest.commonUserInfo.recruiterEmail = this.recruiter.recruiterEmail;
    this.referFriendRequest.companyCode =
      vxm.jobs.BrandingInfo.companycode || '';
    this.referFriendRequest.internalReferral = true;
    //hard coded to 04 as per api specification
    this.referFriendRequest.referralType = '04';

    vxm.referrals.internalReferFriend(this.referFriendRequest).then(() => {
      if (vxm.referrals.EmployeeReferralResponse.errorCode) {
        this.$wlToastr(
          'error',
          vxm.referrals.EmployeeReferralResponse.errorMessage,
          '',
        );
      } else {
        this.$wlToastr(
          'success',
          vxm.referrals.EmployeeReferralResponse.successMessage,
          '',
        );
       
        this.mailClientOpener(this.friendInfo.email);
        
        this.friendInfo = new InternalReferralUserInfo();
        this.referFriendRequest = new InternalReferralFriendRequest();
        this.recruiter = new Recruiter();
        this.recruiterResponse = new RecruiterResponse();
        this.componentKey += 1;
      }
    });
  }
  get isAutomateEmails(){
  return vxm.configs.getGlobalConfigValue('WL_AUTOMATE_REFERRAL_EMAILS');
}
  

  printSearchText(searchText: string) {
    this.recruiterRequest.searchString = searchText;
    this.recruiterRequest.company = vxm.jobs.BrandingInfo.companycode;
    if (searchText.trim().length >= 3) {
      this.recruiterRequest.pageNumber = 1;
      this.recruiterRequest.pageSize = 5;
      const respPromise: any = vxm.referrals
        .getRecruiterListByCompany(this.recruiterRequest)
        .then((values) => {
          if (vxm.referrals.RecruiterResponse.recruiterList !== null) {
            this.recruiterResponse = vxm.referrals.RecruiterResponse;
          }
        });
    }
  }
}
